/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Email_LabelInputs */



/**
* | output |
* | --- |
* | "Email" |
*
* @param {Team_Manager_Email_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_email_label = /** @type {((inputs?: Team_Manager_Email_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Email_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("E-mail")
	if (locale === "de") return /** @type {LocalizedString} */ ("E-Mail")
	if (locale === "it") return /** @type {LocalizedString} */ ("E-mail")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Электронная почта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Correo electrónico")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("电子邮件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メール")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ईमेल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("E-mail")
	return /** @type {LocalizedString} */ ("Email")
});